import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import LinkIcon from "@material-ui/icons/Link";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import * as Glob from "src/Globale";
import * as Dati from "src/Dati";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _BindersListTable } from "../components";
import { _Autocomplete } from "../form";
import useTable from "../hooks/Table";

export const _BindersList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({ ID_Binder: "", CodiceBinder: "", ID_AnagDa: "", ID_AnagA: "" });
    const { Data, Options, IsLoading } = useTable("/api/Binder/Ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("BinderController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={LinkIcon} Title="Binder">
                    {Glob.AzioneAbilitata("BinderController", Glob.Scrittura) && (
                        <a href="/binder/0">
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent>
                    <form noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="ID_Binder"
                                    label={Trad.Trad("ID")}
                                    value={FormData.ID_Binder}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    fullWidth
                                    id="CodiceBinder"
                                    label={Trad.Trad("Codice binder")}
                                    value={FormData.CodiceBinder}
                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <_Autocomplete
                                    Value={FormData.ID_AnagDa}
                                    Name="ID_AnagDa"
                                    Label="Da"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <_Autocomplete
                                    Value={FormData.ID_AnagA}
                                    Name="ID_AnagA"
                                    Label="A"
                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                />
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid item md={1}>
                                <_Button
                                    Attivo={!IsLoading}
                                    Testo={Trad.Trad("Cerca")}
                                    OnClick={() => {
                                        Options.onChangePage(0);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                    <_BindersListTable Data={Data} IsLoading={IsLoading} Options={Options} />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BindersList.tsx